module.exports = __webpack_public_path__ + "img/wide.8c9b0b10.png";